// Module
var code = "<i class=\"difference-flag\"> <span ng-if=\"isDifferent()\" data-popover=\"{{ 'Current ' + label + ': ' + (currentDisplayValue || currentValue) }}\" popover-placement=\"top\" popover-append-to-body=\"true\" popover-trigger=\"mouseenter\"> <i class=\"fa fa-flag\"></i> </span> </i> ";
// Exports
module.exports = code;